import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRoot from "./withRoot";
import { Divider, Typography } from "@material-ui/core";

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit,
    },
    bottom: {
        width: "100%",
        position: "absolute",
        bottom: 0,
        left: 0,
    },
    changelog: {
        width: "500px",
    }
});

class DefaultPage extends Component {
    render() {
        const { classes } = this.props;

        return (
            <div className={classes.margin}>
                <Typography variant="headline">5th edition Dungeons &amp; Dragons Tools</Typography>
                <div className={classes.changelog}>
                    <Typography variant="subheading">Changelog</Typography>
                    <Typography variant="body2">v0.2</Typography>
                    <Typography>The second iteration adds a tool to manage your travel estimation, planning, and progression needs.</Typography>
                    <Typography>- FIX: Dice Roller, modifier can now be changed to 0 and below.</Typography>
                    <Typography>
                        - Travel Planner, based on hourly travel from the <i>Special Travel Pace</i> section in the <i>DMG</i>.
                        Supports (hopefully) all rules I for travelling.
                        Includes a travel log to show progression during travel. <br />
                        Planned additions: Cap travel time to not go beyond travel distance, log travel distance, and save/load travel log.
                    </Typography>
                    <br />
                    <Typography variant="body2">v0.1</Typography>
                    <Typography>The first iteration of this toolset is created to easily roll random loot as well as determining properties of magical items.</Typography>
                    <Typography>- Treasure Generator, for both individual treasure and treasure hoards.</Typography>
                    <Typography>- Dice Roller.</Typography>
                    <Typography>- Item Helpers, to roll random properties for items covering: Damage type, ammunition, armors, weapons, spells, content, and special features. Most helpers have a set of filters to help roll the right item.</Typography>
                </div>
                <div className={classes.bottom}>
                    <Divider className={classes.margin} />
                    <Typography align="center">All content and rules are the intellectual property of Wizards of the Coast.</Typography>
                    <Typography align="center">This site is not affiliated with Wizards of the Coast.</Typography>
                    <Typography align="center">Contact: <a href="mailto:dannibschou@gmail.com">Email</a> <a href="https://twitter.com/DanniSchou">Twitter</a></Typography>
                </div>
            </div>
        );
    }
}

DefaultPage.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Kitsune Kit", withStyles(styles)(DefaultPage));


// WEBPACK FOOTER //
// ./src/DefaultPage.js